import * as React from 'react';
import { MobileFiltersButton } from '../../components/MobileFiltersButton';
import { useFiltersButton } from '../../hooks';

export const MobileFiltersButtonContainer = () => {
  const handleClick = useFiltersButton();

  return <MobileFiltersButton onClick={handleClick} />;
};
